import React from 'react'
import PropTypes from 'prop-types'
import './GlyphiconButton.css'

const GlyphiconButton = ({ onClick, backgroundColor, borderColor = backgroundColor, children, title }) => (
    <button
        className='btn GlyphiconButton'
        type='button'
        title={title}
        style={{ backgroundColor, borderColor }}
        onClick={onClick}
    >
        {children}
        {title && <span style={{marginTop: '1px'}}>{title}</span>}
    </button>
)

GlyphiconButton.propTypes = {
    onClick: PropTypes.func
}

export default GlyphiconButton
